import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ecamedia',
  templateUrl: './ecamedia.component.html',
  styleUrls: ['./ecamedia.component.css']
})
export class EcamediaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
